export default "__VITE_ASSET__bcf2520b__"